import carnia from "./Carnia.jpg";
import alora from "./Alora.jpg";
import caviana from "./Caviana.jpg";
import corsica from "./Corsica.webp";
import evia from "./Evia.jpg";
import islandero from "./Islandero/Islandero.webp";
import islandero2 from "./Islandero/Islandero (1).webp";
import islandero3 from "./Islandero/Islandero (2).webp";
import islandero4 from "./Islandero/Islandero (3).webp";
import islandero5 from "./Islandero/Islandero (4).webp";
import islandero6 from "./Islandero/Islandero (5).webp";
import islandero7 from "./Islandero/Islandero (6).webp";
import islandero8 from "./Islandero/Islandero (7).webp";
import moorea from "./Moorea.jpg";
import tetiara from "./Tetiara.jpg";
import tuscan from "./Tuscan/Tuscan.webp";
import tuscan2 from "./Tuscan/tuscan (2).webp";
import tuscan3 from "./Tuscan/tuscan (3).webp";
import tuscan4 from "./Tuscan/tuscan (4).webp";
import tuscan5 from "./Tuscan/tuscan (5).webp";
import tuscan6 from "./Tuscan/tuscan (6).webp";
import tuscan7 from "./Tuscan/tuscan (7).webp";
import tuscan8 from "./Tuscan/tuscan (8).webp";
import tuscan9 from "./Tuscan/tuscan (9).webp";
import tuscan10 from "./Tuscan/tuscan (10).webp";
import tuscan11 from "./Tuscan/tuscan (11).webp";
import tuscan12 from "./Tuscan/tuscan (12).webp";
import velaa from "./Velaa.jpg";
import venesa from "./Venesa.webp";
import revania from "./Revania/revania (1).webp";
import revania2 from "./Revania/revania (2).webp";
import revania3 from "./Revania/revania (3).webp";
import revania4 from "./Revania/revania (4).webp";
import revania5 from "./Revania/revania (5).webp";
import revania6 from "./Revania/revania (6).webp";
import revania7 from "./Revania/revania (7).webp";
import revania8 from "./Revania/revania (8).webp";
import revania9 from "./Revania/revania (9).webp";
import revania10 from "./Revania/revania (10).webp";
import revania11 from "./Revania/revania(1).webp";
import victoria from "./Victoria/Victoria.webp";
import victoria2 from "./Victoria/victoria (1).webp";
import victoria3 from "./Victoria/victoria (2).webp";
import victoria4 from "./Victoria/victoria (3).webp";
import victoria5 from "./Victoria/victoria (4).webp";
import victoria6 from "./Victoria/victoria (5).webp";
import victoria7 from "./Victoria/victoria (6).webp";
import victoria8 from "./Victoria/victoria (7).webp";
import victoria9 from "./Victoria/victoria (8).webp";
import victoria10 from "./Victoria/victoria (9).webp";

const carniaImages = [carnia, carnia];
const aloraImages = [alora, alora];
const cavianaImages = [caviana, caviana];
const corsicaImages = [corsica, corsica];
const eviaImages = [evia, evia];
const islanderoImages = [
  islandero,
  islandero2,
  islandero3,
  islandero4,
  islandero5,
  islandero6,
  islandero7,
  islandero8,
];
const mooreaImages = [moorea, moorea];
const tetiaraImages = [tetiara, tetiara];
const tuscanImages = [
  tuscan,
  tuscan2,
  tuscan3,
  tuscan4,
  tuscan5,
  tuscan6,
  tuscan7,
  tuscan8,
  tuscan9,
  tuscan10,
  tuscan11,
  tuscan12,
];
const velaaImages = [velaa, velaa];
const venesaImages = [venesa, venesa];
const revaniaImages = [
  revania11,
  revania,
  revania2,
  revania3,
  revania4,
  revania5,
  revania6,
  revania7,
  revania8,
  revania9,
  revania10,
];
const victoriaImages = [
  victoria,
  victoria2,
  victoria3,
  victoria4,
  victoria5,
  victoria6,
  victoria7,
  victoria8,
  victoria9,
  victoria10,
];
export {
  carniaImages,
  aloraImages,
  cavianaImages,
  corsicaImages,
  eviaImages,
  islanderoImages,
  mooreaImages,
  tetiaraImages,
  tuscanImages,
  velaaImages,
  venesaImages,
  revaniaImages,
  victoriaImages,
};
